import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pureFilter',
  pure: true
})
export class PureFilterPipe implements PipeTransform {

  transform(list: any[], fn: Function): any[] {
    if (!list || !fn) {
      return list;
    }
    return list.filter((value, idx, arr) => fn(value, idx, arr));
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/pipes/pure-filter.pipe.ts